import { AnnouncementFrequencies, AnnouncementPersonalizationDto, AnnouncementTemplateDto, ScheduleDayOffset } from '@inosio/payments-sdk';
import { placeholderKeyRegex } from '../../../../utils/regex';
import { format, parseISO } from 'date-fns';

export const extractPlaceholderKeysFromTheText = (text: string) => {
  const matches = text.match(placeholderKeyRegex) || [];
  return matches;
};

export const filterDistinctPersonalizations = (subject: string, body: string, personalizations: AnnouncementPersonalizationDto[]) : AnnouncementPersonalizationDto[] | undefined  => {
  const personalizationsKeys = [...extractPlaceholderKeysFromTheText(subject), ...extractPlaceholderKeysFromTheText(body)];

  // Filter the personalizations array to only include matching personalization keys
  const distinctPersonalizations = personalizationsKeys
    .map((key) => {
      // Find the first match from the personalization array
      return personalizations?.find((personalization) => personalization.Key === key);
    })
    .filter((personalization) => personalization !== undefined);

  return distinctPersonalizations as AnnouncementPersonalizationDto[]
};

export const allMonths = Array.from({ length: 12 }, (_, index) => ({Id: index, Name: format(new Date(2025, index), 'MMMM')}));

export const ScheduleDayOffsetOptions: { label: string; value: ScheduleDayOffset| string }[] = [
  {
    value: 'OnThisDay',
    label: 'On this day',
  },
  {
    value: ScheduleDayOffset.FirstBusinessDayOnOrAfterCalendarDate,
    label: 'On this day or the business day after',
  },
  {
    value: ScheduleDayOffset.FirstBusinessDayOnOrBeforeCalendarDate,
    label: 'On this day or the business day before',
  },
]

const frequencyStringMapper: Record<AnnouncementFrequencies, string> = {
  [AnnouncementFrequencies.Monthly]: "month",
  [AnnouncementFrequencies.Quarterly]: 'quarter',
  [AnnouncementFrequencies.OneTime]: '',
  [AnnouncementFrequencies.Daily]: ''
};

const scheduleDayOffsetStringMapper: Record<ScheduleDayOffset, string> = {
  [ScheduleDayOffset.FirstBusinessDayOfTheMonth]: '',
  [ScheduleDayOffset.LastBusinessDayOfTheMonth]: '',
  [ScheduleDayOffset.FirstBusinessDayOnOrAfterCalendarDate]: ' (or the business day after)',
  [ScheduleDayOffset.FirstBusinessDayOnOrBeforeCalendarDate]: ' (or the business day before)',
  [ScheduleDayOffset.OnThisDay]: ''
};


/**
 * Ie : This message will be sent on day [day] (or the business day before) at 02:00 PM, every [month/quarter], starting on [Month] [year]
 * @param announcementDetail
 **/
export const generateRecurringAnnouncementSentence = (announcementDetail : AnnouncementTemplateDto) => {
  if (announcementDetail.FirstSendDatetime && announcementDetail.Frequency) {

    const firstSendDateTime = parseISO(announcementDetail.FirstSendDatetime);
    const monthName = format(firstSendDateTime, 'MMMM');
    const date = format(firstSendDateTime, 'd');
    const time = format(firstSendDateTime, 'hh:mm a');
    const interval = frequencyStringMapper[announcementDetail.Frequency] 
    const offset = scheduleDayOffsetStringMapper[announcementDetail.ScheduleDayOffset!] ?? ''
   const sentence = `This message will be sent on day ${date}${offset} at ${time}, every ${interval}, starting in ${monthName} ${firstSendDateTime.getUTCFullYear()}`;
    return sentence;
  }
  return null;
}